import React, { Component } from 'react';
import '../css/Menu.css';
import factura from '../img/facturacion.png';
import plata from '../img/plata.png';
import '../js/Eventoclick.js';
class Menu extends Component {
  render() {
    return (
      <div id="body-Menu">
        <nav id='menu-id' className="navbar navbar-inverse">
          <div>
            <div className="navbar-header">
              <button id="menu-responsi-id" type="button" data-target="#opciones-menu"
                className="menu-responsi">Menu</button>

              <a className="navbar-brand" href="#">NOI SYSTEMS</a>
            </div>
            <ul id="opciones-menu" className="nav navbar-nav">
              <li><a id='button-inicio' className="inicio" href="#">INICIO</a></li>
              <li><a id='button-productos' className="producto" href="#id-productos">PRODUCTOS</a></li>
              <li><a id='button-manuales' className="manuales" href="#id-manuales">MANUALES</a></li>
              <li><a id='button-nosotros' className="nosotros" href="#id-nosotros">NOSOTROS</a></li>
              <li><a id='button-contactenos' className="contactenos" href="#contactos-final">CONTACTENOS</a></li>
              <li><a id='button-politicas' className="proliticas" href="#politicas">POLITICAS</a></li>
            </ul>
          </div>
        </nav>
        <div id="container-menu">
          <div id="myCarousel" class="carousel slide" data-ride="carousel">
            <ol id='indicator' class="carousel-indicators">
              <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
              <li data-target="#myCarousel" data-slide-to="1" class=""></li>
            </ol>
            <div class="carousel-inner">
              <div class="item active" id='fondo-menu'>
                <div className="cuadro">
                  <strong className="titulo">NOI SYSTEMS S.R.L.</strong>
                  <hr className="borde-azul"></hr>
                  <h1 className="parrafo">Facturación electrónica integrada con Noi Systems</h1>
                  <h4 className="parrafo2">Emita sus comprobantes de manera fácil y segura.</h4>
                  <a id="info" href="#factura" className="btn btn-primary">
                    <p className="parrafo-bottom">Más Información</p>
                  </a>
                </div>
              </div>
              <div class="item" id='fondo2-menu'>
                <div className="cuadro">
                </div>
              </div>
            </div>
            <a class="left carousel-control" href="#myCarousel" data-slide="prev">
              <span class="glyphicon glyphicon-chevron-left"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="right carousel-control" href="#myCarousel" data-slide="next">
              <span class="glyphicon glyphicon-chevron-right"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
        <div class="modal-wrapper" id="factura">
          <div class="factura-menu">
            <div id="foto-factura">
              <h4 className="titulo-factura">Facturación Electrónica</h4>
            </div>
            <div className="caja-factura">
              <p className="parrafo-factura" >Gestione su proceso comercial sin dificultades.</p>
              <img className="imagen-factura" src={factura}></img>
              <h2 className="titulo2-factura" >Facilidad y Rapidez para Homologar su Factura</h2>
              <h5 className="titulo3-factura">tenemos experiencia de homologacion con mas de 3 proveedores</h5>
              <div className="caja2-factura">
                <div>
                  <img className="imagen-factura2" src={plata}></img>
                </div>
                <div className="caja3-factura">
                  <h1 className="titulo4-factura">Contabilización automática <br />de su factura electrónica</h1>
                  <h4 className="titulo5-factura">Lleve un registro de sus movimientos bancarios y del estado de las facturas.</h4>
                  <p className="parrafo2-factura">
                    Utilice el resumen de estado para poder realizar el seguimiento de <br />
                    los borradores, las facturas pagadas y las facturas no pagadas. <br />
                  </p>
                </div>

              </div>
              <div className="caja4-factura">
                <h4 className="titulo6-factura">¡Empieza ahora! Libere su potencial de crecimiento.</h4>
                <a id="contactos-menu" href='#contactos-final' className="btn btn-primary">
                  <p className="parrafo-bottom">CONTÁCTANOS</p>
                </a>
              </div>
            </div>
            <a id="cerrar" class="factura-cerrar" href="#myCarousel">X</a>
          </div>
        </div>
      </div>
    )
  }

}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.jsx